<template>
    <div>
        <!--<input type="file" ref="fileInput" accept="image/*" multiple @change="handleFileUpload">-->
        <v-file-input ref="fileInput" @change="handleFileUpload" :label="$t('UploadImages')" multiple accept="image/*"
                      outlined
                      dense></v-file-input>
        <div v-if="uploadedImages.length > 0">
            <h2>{{ $t('UploadedImages') }}</h2>
            <div class="image-preview" v-for="(imageData, index) in uploadedImages" :key="index">
                <img :src="imageData.picSrc" style="max-width: 200px; margin: 10px; cursor: pointer;" @click="selectImage(index)">
                <button type="button" @click="removeImage(index)" class="delete-btn">
                    <span class="mdi mdi-close-circle"></span>
                </button>
                <v-text-field dense outlined v-model="imageData.label" :label="$t('Label')" @input="updateImageLabel(index)"></v-text-field>
            </div>
        </div>
        <v-dialog v-model="dialog" v-if="selectedImage !== null" class="text-center" :fullscreen="false" width="35%" show-action-toolbar>
            
                <v-card-title class="text-h5 secondary">
                    {{ selectedImage.label }}
                </v-card-title>
                <img :src="selectedImage.picSrc" style="max-height:50%; max-width:100%">
            
        </v-dialog>
       
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        components: {
            
        },
        props: {
            value: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                uploadedImages: [],
                selectedImage: null,
                dialog: false
            }
        },
        watch: {
            uploadedImages: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            handleFileUpload(files) {
                if (!files.length) return

                for (let i = 0; i < files.length; i++) {
                    const file = files[i]
                    if (!this.validateImageType(file)) {
                        console.error(`File ${file.name} is not a valid image type.`)
                        continue
                    }
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        this.uploadedImages.push({ picSrc: e.target.result, label: '' })
                    }
                    reader.readAsDataURL(file)
                }
            },
            validateImageType(file) {
                const allowedTypes = ['image/jpeg', 'image/png', 'image/gif']
                return allowedTypes.includes(file.type)
            },
            closeModal() {
                this.selectedImage = null
            },
            selectImage(index) {
                this.selectedImage = this.uploadedImages[index]
                this.dialog = true
            },
            removeImage(index) {
                this.uploadedImages.splice(index, 1)
            },
            updateImageLabel(index) {
                // Retain spaces within the label
                this.uploadedImages[index].label = this.uploadedImages[index].label
            },
            clearUploadedImages() {
                this.uploadedImages = []
            }
        },
        mounted() {
            this.uploadedImages = this.value.map(img => ({ picSrc: img.picSrc, label: img.label || '' }))
        }
    }
</script>

<style scoped>
    .image-preview {
        display: inline-grid;
        text-align: center;
        position: relative;
        margin: 10px;
    }

        .image-preview img {
            width: 200px;
            height: 200px;
            cursor: pointer;
        }

    .delete-btn {
        position: absolute;
        top: 10px;
        right: 15px;
    }

    .modal {
        display: block;
        position: fixed;
        z-index: 999;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        overflow: auto;
        padding-top: 50px;
    }

        .modal img {
            margin: auto;
            display: block;
            max-width: 80%;
            max-height: 80%;
        }

    .close {
        position: absolute;
        top: 50px;
        right: 90px;
        color: #f1f1f1;
        font-size: 40px;
        font-weight: bold;
        cursor: pointer;
    }

        .close:hover,
        .close:focus {
            color: #bbb;
            text-decoration: none;
            cursor: pointer;
        }

    .image-label {
        margin: 0px 15px;
        width: 70%;
        box-sizing: border-box;
        text-transform: none; /* Avoid uppercase transformations */
        white-space: normal; /* Allow wrapping if needed */
    }
</style>
